import { styled as r } from "@lokalise/styled";
import { value as o, typography as e } from "../../utils/theme/index.js";
import { Content as n, Arrow as t } from "../Popover/styles.js";
const l = r(n)`
	font: ${o("font.family.default")};
	${e("body.caption.default")};
	background-color: ${o("color.background.surface.inverse")};
	color: ${o("color.text.inverse")};
	border-radius: ${o("radius.tooltip")};
	padding: 3px 8px 4px;
	border-color: ${o("color.background.surface.inverse")};
	z-index: ${o("zIndex.tooltip")};
`, i = r(t)`
	&:before {
		background-color: ${o("color.background.surface.inverse")};
		border-color: ${o("color.background.surface.inverse")};
	}
`;
export {
  i as Arrow,
  l as Content
};
//# sourceMappingURL=styles.js.map
